/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
const a="20211214",b="2f62aa11eb308d30278a805efbaca7231370b0d8";export{a as buildDate,b as commitHash};
